import { storageSession } from '@common/utils/Storage/Storage';
export var getCachedChunkById = function (id) {
    var chunksCached = storageSession.get('uploadedChunks');
    return chunksCached === null || chunksCached === void 0 ? void 0 : chunksCached[id];
};
